import { useSupport } from '@/contexts/SupportContext';
import { useSurvey } from '@/hooks/use-survey';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@beacon/ui/components';

export function SidebarHelp({ collapsed }: { collapsed?: boolean }) {
  const { openSupport } = useSupport();
  const feedback = useSurvey('beacon-feedback');

  const trigger = collapsed ? (
    <Tooltip>
      <TooltipTrigger asChild>
        <button
          aria-label="Help & support"
          className="text-text-3 hover:bg-surface-2 hover:text-text-1 flex w-full justify-center rounded py-1.5 transition-colors"
        >
          <Icon symbol="customer-service-2-line" className="h-[18px] w-[18px]" />
        </button>
      </TooltipTrigger>
      <TooltipPortal>
        <TooltipContent side="right">Help & support</TooltipContent>
      </TooltipPortal>
    </Tooltip>
  ) : (
    <button className="text-text-2 hover:bg-surface-2 hover:text-text-1 flex w-full items-center gap-2.5 rounded px-2.5 py-2 text-xs font-medium transition-colors">
      <Icon symbol="customer-service-2-line" className="text-text-3 h-4 w-4 shrink-0" />
      Help &amp; support
    </button>
  );

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>{trigger}</DropdownMenuTrigger>
      <DropdownMenuContent side={collapsed ? 'right' : 'top'} align={collapsed ? 'end' : 'start'} className="w-52">
        <DropdownMenuItem onSelect={() => openSupport('support')}>
          <span className="flex items-center gap-2">
            <Icon symbol="customer-service-2-line" className="h-4 w-4" />
            Contact support
          </span>
        </DropdownMenuItem>
        <DropdownMenuItem onSelect={() => openSupport('bug')}>
          <span className="flex items-center gap-2">
            <Icon symbol="error-warning-line" className="h-4 w-4" />
            Report a bug
          </span>
        </DropdownMenuItem>
        {feedback.available && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => feedback.open()}>
              <span className="flex items-center gap-2">
                <Icon symbol="chat-poll-line" className="h-4 w-4" />
                Share feedback
              </span>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
